import React from 'react';
import ReactModal from 'react-modal';
import classnames from 'classnames';
import closeIcon from '../../Images/close_icon.png';

export const ModalHeader = (props) => {
    return (
        <div className="modal-header">
            {props.onClose &&
                <a className="close close--viiad" aria-label="Close" onClick={props.onClose}>
                    <span aria-hidden="true"><img src={closeIcon} width="20" height="20" /></span>
                </a>
            }
            {props.enableBackButton &&
                <a className="modal-back-btn" onClick={props.onBack}>&lt; {props.backButtonText}</a>
            }

            <h2 className="modal-title text-center">{props.title}</h2>
        </div>
    );
}

export const ModalBody = (props) => {
    return (
        <div className="modal-body modal-body--nopadding">
            {props.children}
        </div>
    );
}


export const ModalFooter = (props) => {

    const textNeg = props.textNeg || "Close";
    const textPos = props.textPos || "OK";
    const className = props.className || "modal-footer--md modal-footer--centered";
    return (<div className={"modal-footer " + className}>
        {props.handleNeg &&
            <a className={"btn btn--transparent-primary btn-pill btn--flat" + (props.classNameNeg || "")}
                onClick={props.handleNeg}>{textNeg}</a>
        }
        {props.handlePos &&
            <a className={"btn-size--lg btn-solid--primary " + (props.classNamePos || "")}
                onClick={props.handlePos}>{textPos}</a>
        }
    </div>);
};

/**
 * Generic Perspecta branded modal/overlay
 */
export const PerspectaModal = ({
    rootClasses, // Additional classes to add to root modal element
    dialogClasses, // Additional classes to add to modal-dialog elemnt
    size, // sm, md, lg (adds .modal-X class to modal-dialog element)
    isOpen,
    title,
    enableBackButton,
    backButtonText,
    onBack,
    onClose,
    children,
    environment,
    wrapper
}) => {
    wrapper = wrapper == null ? "wrapper" : wrapper;
    let reactModalRootClasses = classnames('modal show', rootClasses);

    let modalDialogSizeClass = 'modal-md';
    if (size) {
        modalDialogSizeClass = 'modal-' + size;
    }
    let modalDialogClasses = classnames('modal-dialog', dialogClasses, modalDialogSizeClass);

    return (
        <ReactModal
            className={reactModalRootClasses}
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel={title}
            closeTimeoutMS={200}
            appElement={document.getElementsByClassName(wrapper)[0]}>
            <div className={modalDialogClasses}>
            
                <div className="modal-content">
                    <ModalHeader
                        contentRoot={environment.CONTENT_ROOT}
                        title={title}
                        backButtonText={backButtonText}
                        enableBackButton={enableBackButton}
                        onClose={onClose}
                        onBack={onBack}
                    />

                    <ModalBody>
                        {children}
                    </ModalBody>
                </div>
            </div>
        </ReactModal>
    );
}

/**
 * Modal Navigation
 */
export class ModalNav extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <div className="modal-nav">
                {this.props.children}
            </div>
        );
    }
}

export class ModalNavTab extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={classnames('modal-nav__item', {
                'modal-nav__item--active': this.props.activeTab === this.props.tabKey
            })}>
                <a onClick={this.handleClick}>{this.props.title}</a>
            </div>
        );
    }

    handleClick = (e) => {
        if (this.props.onClick) {
            this.props.onClick(this.props.tabKey);
        }
    }
}

export const ModalInfoMessage = (props) => {
    return (
        <div className="text-center margin-top-lg margin-bottom-lg">
            <h4>{props.message}</h4>
        </div>
    );
}